import { useRef, useState } from 'react';
import { UPLOAD_CONFIG } from '@/config';
import { handleFileUpload } from '@/utils/files/upload';
import { UploadZone } from './UploadZone';
import { FilePreview } from './FilePreview';

interface FileUploadFieldProps {
  type: 'image' | 'pdf';
  value: string;
  onChange: (value: string) => void;
  label: string;
  onError?: (error: string) => void;
  previewUrl?: string;
}

export function FileUploadField({
  type,
  value,
  onChange,
  label,
  onError,
  previewUrl
}: FileUploadFieldProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDragActive, setIsDragActive] = useState(false);

  const maxSize = type === 'image' ? UPLOAD_CONFIG.MAX_IMAGE_SIZE : UPLOAD_CONFIG.MAX_PDF_SIZE;
  const accept = type === 'image' 
    ? UPLOAD_CONFIG.ACCEPTED_IMAGE_TYPES.join(',') 
    : UPLOAD_CONFIG.ACCEPTED_PDF_TYPES.join(',');

  const handleFileSelect = async (file: File) => {
    const base64 = await handleFileUpload(file, maxSize, onError);
    if (base64) {
      onChange(base64);
    }
  };

  return (
    <div 
      className="space-y-4"
      onDragEnter={() => setIsDragActive(true)}
      onDragLeave={() => setIsDragActive(false)}
    >
      {value ? (
        <FilePreview
          type={type}
          previewUrl={previewUrl}
          fileName={type === 'pdf' ? 'السيرة الذاتية.pdf' : undefined}
          onRemove={() => onChange('')}
        />
      ) : (
        <UploadZone
          onFileSelect={handleFileSelect}
          accept={accept}
          maxSize={maxSize}
          label={label}
          inputRef={inputRef}
          isDragActive={isDragActive}
        />
      )}
    </div>
  );
}